import { render, staticRenderFns } from "./CreatePlanningTrainingPage.vue?vue&type=template&id=57894c48&"
import script from "./CreatePlanningTrainingPage.vue?vue&type=script&lang=js&"
export * from "./CreatePlanningTrainingPage.vue?vue&type=script&lang=js&"
import style0 from "./CreatePlanningTrainingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports